
        import '/home/builduser/work/575538235ca6a4de/santa-editor/packages/textEditor/textEditor.scss.css.virtualfile';
        module.exports = {"textEditor__pimple":"_textEditor__pimple_dhq68_1","textEditorPimple":"_textEditor__pimple_dhq68_1"};